module.exports = __webpack_public_path__ + "img/partner4.42affdec.png";